import { motion } from "framer-motion";
import { Reveal, SectionTag, SectionTitle, StatusBadge } from "./shared";
import { HIDDEN_CARDS } from "../data/site";

export function HiddenOpportunity() {
  return (
    <section className="relative py-28 lg:py-40 bg-[#0D0D0D]" data-testid="hidden-opportunity-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTag center>The Hidden Opportunity</SectionTag>
        <SectionTitle className="text-center text-4xl sm:text-5xl lg:text-6xl">
          Look Beyond <span className="text-gold-gradient italic">the Airport.</span>
        </SectionTitle>
        <Reveal delay={0.15}>
          <p className="text-center text-sm text-[#71717A] mt-5 max-w-xl mx-auto">
            The real opportunity may be the ecosystem being built around it.
          </p>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="hidden-cards-grid">
          {HIDDEN_CARDS.map((c, i) => (
            <motion.div
              key={c.title}
              data-testid={`hidden-card-${c.title.toLowerCase()}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: (i % 3) * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="group relative p-7 border border-[#D4AF37]/12 bg-[#101010] rounded-[2px] overflow-hidden hover:border-[#D4AF37]/55 transition-colors duration-700"
            >
              <div className="absolute -top-10 -right-10 w-28 h-28 rounded-full bg-[#D4AF37]/0 group-hover:bg-[#D4AF37]/10 blur-2xl transition-all duration-700" />
              <div className="flex items-start justify-between mb-6">
                <span className="font-serif-lux text-3xl text-[#D4AF37]/25 group-hover:text-[#D4AF37]/70 transition-colors duration-700">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <StatusBadge status={c.status} />
              </div>
              <h3 className="font-serif-lux text-2xl text-[#F5F5F0] group-hover:text-[#F3E5AB] transition-colors duration-500">{c.title}</h3>
              <p className="text-[11px] uppercase tracking-[0.2em] text-[#D4AF37]/80 mt-1 mb-3">{c.subtitle}</p>
              <p className="text-[13px] text-[#71717A] leading-relaxed">{c.desc}</p>
            </motion.div>
          ))}
        </div>

        <Reveal delay={0.2}>
          <h3 className="mt-20 text-center font-serif-lux text-3xl sm:text-4xl lg:text-5xl" data-testid="hidden-reveal-line">
            <span className="text-[#F5F5F0]">Multiple Demand Drivers. </span>
            <span className="text-gold-gradient italic">One Emerging Corridor.</span>
          </h3>
        </Reveal>
      </div>
    </section>
  );
}
